import { css, jsx } from '@emotion/core';
import React from 'react';

import { bp } from '@/styles';

import Components from './Components';

const style = {
  topicsContainer: css`
    display: block;

    @media ${bp.md} {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 0 -12px;
    }
  `,
};

const Topics = props => {
  const { blockData, entities } = props;

  let topicComponents = [];
  if (blockData.Components && Array.isArray(blockData.Components)) {
    topicComponents = blockData.Components.map(c => entities.Components[c]);
  }

  return (
    <div css={style.topicsContainer}>
      {topicComponents.map(tc => (
        <Components componentData={tc} />
      ))}
    </div>
  );
};
export default Topics;
